/*
 * Copyright (c) 2023. Data Smart Technologies CC
 * https://www.datasmart.co.za
 * View license agreement and terms of use at https://www.datasmart.co.za/legal
 *
 * @author  Juan <juan@datasmart.co.za>
 * @version 1.0
 * @updated 2023-07-11
 */


import React from "react";

export const ContactInformation: React.FC = () => {
    return (
        <>
            {/* <div className="row"> */}
                <div className="col-12">
                    <p className="jc-txt-black fs-5 mb-2 mt-4">Email: <a href="mailto:admin@uoscape.co.za" className="jc-txt-body jc-txt-black fs-7">admin@uoscape.co.za</a></p>
                    <p className="jc-txt-black fs-5 mb-4">Tel: <span className="jc-txt-body fs-7">+27 21 461 6310</span></p>
                </div>

                <div className="col-md-6">
                    <p className="jc-txt-black fs-5 mb-2">Physical Address</p>
                    <p className="jc-txt-body jc-txt-black fs-7 mb-4">
                        191 Buitenkant Street<br/>
                        Gardens<br/>
                        Cape Town<br/>
                        South Africa<br/>
                        8001
                    </p>
                </div>

                    {/* <p className="jc-txt-black fs-5 mb-2">Postal Address</p>
                    <p className="jc-txt-body jc-txt-black fs-7 mb-4">
                        PO Box 5438000<br/>
                        Cape Town<br/>
                        South Africa
                    </p> */}
            {/* </div> */}

            <div className="col-md-6 jc-txt-body">
                
                
                {/* <p className="jc-txt-black fs-5 mb-4">Fax: <span className="jc-txt-body fs-7">+27 21 461 8320</span></p> */}

                <p className="jc-txt-black fs-5 mb-2">Bank Details</p>
                <p className="jc-txt-body jc-txt-black fs-7">
                    Cemetery Maintenance Board<br/>
                    ABSA<br/>
                    Wynberg 632005<br/>
                    Account 01023530534<br/>
                    Swift Code ABSA ZAJJ
                </p>
            </div>
        </>
    );
}